export default "__VITE_ASSET__5KmUJWDK__"